module.exports = __webpack_public_path__ + "img/Antonia&Stephan-01.fc5a03dc.jpg";